/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './glucose.reducer';

export const GlucoseDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const glucoseEntity = useAppSelector(state => state.glucose.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="glucoseDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.glucose.detail.title">Glucose</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.glucose.id">Id</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.id}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.glucose.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.glucose.active">Active</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.glucose.created">Created</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.created ? <TextFormat value={glucoseEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.glucose.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.microSec}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.glucose.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.notes}</dd>
          <dt>
            <span id="reading">
              <Translate contentKey="tinyMedicRestApp.glucose.reading">Reading</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.reading}</dd>
          <dt>
            <span id="readingType">
              <Translate contentKey="tinyMedicRestApp.glucose.readingType">Reading Type</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.readingType}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.glucose.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.glucose.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{glucoseEntity.lastupdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.glucose.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{glucoseEntity.glucoUser ? glucoseEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/glucose" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/glucose/${glucoseEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GlucoseDetail;
